import $axios from '../backend/vue-axios/axios.js'
const state = {
  displays: null,
  tasks: null
}
const mutations = {
  setDisplays (state, payload) {
    state.displays = payload
  },
  resetState (state) {
    state.displays = null
  }
}
const getters = {
  getDisplay (state) {
    return state.displays
  }
}
const actions = {
  callApi ({commit}, payload) {
    commit('resetState')
    $axios.get(payload.url)
    .then(response => {
      let code = []
      if (response.data !== null) {
        response.data.forEach(item => {
          if (item !== null) {
            item.portalFeature.forEach(pf => {
              pf.featureDisplay.forEach(fd => {
                let obj = {
                  id: fd.id,
                  code: fd.code,
                  station: fd.portal_name,
                  displayId: fd.displayId
                }
                code.push(obj)
              })
            })
          }
        })
      }
      commit('setDisplays', code)
    })
  }
}
export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/instructions.js